var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-expand-transition',[_c('h3',[_vm._v(_vm._s(_vm.$t('Welcome'))+" "+_vm._s(_vm.$user.UserName))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }